import { Routes, Route } from "react-router-dom";
import MembersArea from "./components/MembersArea";
import MembersDashboard from "./pages/MembersDashboard";
import MembersHome from "./pages/MembersHome";
import MembersOrders from "./pages/MembersOrders";
import MembersDownloads from "./pages/MembersDownload";
import { ProtectedRoute, AuthRoute } from "./components/ProtectedRoute";
import MembersAddresses from "./pages/MembersAddresses";
import MembersPaymentMethods from "./pages/MembersPaymentMethods";
import MembersAccountDetails from "./pages/MembersAccountDetails";

function MembersRoutes() {
  return (
    <Routes>
      {/* Login Page - NO sidebar */}
      <Route 
        path="/members-area" 
        element={
          <AuthRoute>
            <MembersArea />
          </AuthRoute>
        } 
      />
      
      {/* Dashboard Page - NO sidebar */}
      <Route 
        path="/members-dashboard" 
        element={
          <ProtectedRoute>
            <MembersDashboard />
          </ProtectedRoute>
        } 
      />
      
      {/* Home Page - WITH sidebar */}
      <Route 
        path="/members-home" 
        element={
          <ProtectedRoute>
            <MembersHome />
          </ProtectedRoute>
        }
      />
      
      {/* Orders Page - WITH sidebar */}
      <Route 
        path="/members-orders" 
        element={
          <ProtectedRoute>
            <MembersOrders />
          </ProtectedRoute>
        }
      />
      
      {/* Other pages - WITH sidebar */}
      <Route 
        path="/members-downloads" 
        element={
          <ProtectedRoute>
            <MembersDownloads />
          </ProtectedRoute>
        }
      />
      <Route 
        path="/members-addresses" 
        element={
          <ProtectedRoute>
          <MembersAddresses />
          </ProtectedRoute>
        }
      />
      <Route 
        path="/members-payment-methods" 
        element={
          <ProtectedRoute>
          <MembersPaymentMethods />
          </ProtectedRoute>
        }
      />
      <Route 
        path="/members-account-details" 
        element={
          <ProtectedRoute>
        <MembersAccountDetails />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default MembersRoutes;